import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { renderSections } from "@/components/sections";
import { LANDING_BUILTINS, PORTFOLIO_BUILTINS } from "@/lib/builtinSections";

export const PreviewDialog = ({ open, onOpenChange, section, content }) => {
  const [lang, setLang] = useState("es");
  if (!section) return null;
  const isPortfolio = section.page === "portfolio";
  const builtins = isPortfolio ? PORTFOLIO_BUILTINS : LANDING_BUILTINS;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex h-[90vh] max-w-[95vw] flex-col gap-0 overflow-hidden border-slate-800 bg-slate-900 p-0 text-white" data-testid="preview-dialog">
        <DialogHeader className="flex-row items-center justify-between space-y-0 border-b border-slate-800 px-5 py-3 pr-14">
          <DialogTitle className="font-mono text-sm text-slate-300">// vista.previa — aún sin guardar</DialogTitle>
          {isPortfolio && (
            <div className="flex gap-1 font-mono text-xs" data-testid="preview-lang-toggle">
              {["es", "en"].map((l) => (
                <button key={l} onClick={() => setLang(l)} data-testid={`preview-lang-${l}`}
                  className={`rounded px-2 py-1 uppercase ${lang === l ? "bg-[#FF5500] text-white" : "text-slate-400 hover:text-white"}`}>
                  {l}
                </button>
              ))}
            </div>
          )}
        </DialogHeader>
        <div className={`flex-1 overflow-y-auto ${isPortfolio ? "bg-[#081B33] tech-grid" : "bg-slate-950 text-slate-200"}`} data-testid="preview-body">
          <div className={isPortfolio ? "mx-auto max-w-6xl px-5 pb-10" : "pb-10"}>
            {renderSections([{ ...section, content }], builtins, { lang })}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PreviewDialog;
